// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Qp","link":"e_Rp","imageContainer":"e_Sp","author":"e_Tp","text":"e_Up","buttonIcon":"e_Vp"};